// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__K1MqJ","signatureBlock":"Footer_signatureBlock__2HKQT","signature":"Footer_signature__1SGd3"};